


















import VueOptions from '@utils/VueOptions'

settings = 
  name: 'BrandInfoResourceListItem'
  
  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    methods:
      shouldExpandCollumn: (size) ->
        return true if @rowSize >= 2 && size == 'MEDIUM'
        return true if @rowSize == 3 && size == 'LARGE'

      launch: (item) -> @$router.push({ name: 'BrandInfoShowPage', params: { brandInfoId: item.id } })

      # launchTab(`/brand_infos/${item.id}`, item.id)

export default VueOptions.vue settings
